// import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { IListConfig, IRowData, IGroupData } from 'Src/ng2/shared/models/list-models';
import {
  BackgroundJobNotificationService,
  TValidBackgroundJob,
} from './../../../shared/services/background-job-notification-service/background-job-notification-service';
import {
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { compact as _compact, reduce as _reduce } from 'lodash';
import { BehaviorSubject, Observable, Unsubscribable, Subject, iif } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { SpinnerModal } from 'Src/app/shared/modals/status-spinner/status-spinner.service';
import { FixedToInfiniteViewComponent } from 'Src/ng2/shared/components/list/fixed-to-infinite-view-container/fixed-to-infinite-view.component';
import { ObjectCache } from 'Src/ng2/shared/services/object-cache/object-cache.service';
import { ListSummaryGroupings } from './../../../shared/services/list-summary-groupings/list-summary-groupings.service';
import { ShelterDataService } from './shelter-attendance-data/shelter-attendance-data.service';
import { IFocus } from 'Src/ng2/school/tiles/interfaces/dashboard.interfaces';
import { MadlibService } from 'Src/ng2/school/lists/services/madlib/madlib.service';
import { ListHeaderService } from 'Src/ng2/school/lists/services/list-headers/list-headers.service';
import {
  INgRouterQueryParams,
  NgRouterNavigationService,
} from 'Src/ng2/school/lists/services/list-navigation/ng-router-list-navigation.service.ts';
import { IListData } from 'Src/ng2/shell/content-tools/content-tools.component';
import {
  Direction,
  TSortDirections,
  SortAndFilterService,
} from 'Src/ng2/shared/services/list-services/sort-and-filter.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ModalsService } from 'Src/ng2/shared/modals/modals.service';
import { SpinnerService } from 'Src/ng2/shared/components/spinner/spinner-modal.service';

interface IUrlParams {
  madlibModel: FormGroup;
  sortKey: string;
  sortDirection: string;
  search: string;
}
@Component({
  selector: 'shelter-att-list',
  template: require('./shelter-att-list.component.html'),
  styles: [require('./shelter-att-list.component.scss')],
})
export class ShelterAttListComponent extends FixedToInfiniteViewComponent implements OnInit {
  public isRefactoredList: boolean = true;
  public fociData$: Observable<any>;
  public batchActionsHash: any;
  public madlibModel: FormGroup;
  public dataSource$: Observable<any>;
  public foci: IFocus[];
  public fociByCategory: Array<{ categoryLabel: string; foci: IFocus[] }>;
  public activeList: 'INFINITE' | 'FIXED';
  public uiRowData;
  public visualGroupingData: IGroupData;
  public onUiRowDataUpdate: Function;
  public listData: IListData;
  private hideTools: boolean = true;
  private queryParams: Params;

  // The background jobs does this view need to refetch on?
  public backgroundJobDependencies: TValidBackgroundJob[] = [
    'BulkStudentUpdate',
    'BulkStudentSupportCreate',
    'BulkStudentSupportUpdate',
  ];

  public pageHeaderMeta = {
    title: 'Attendance',
    subTitle: null,
    icon: {
      tooltip: null,
    },
  };

  // SuperProps
  public onFixed: Function;
  public onInfinite: Function;
  public onBatchAction: Function;
  public batchActionsMode$ = of(false);
  public onRowClick: Function;
  public schoolId;
  public columns;
  public dynamicColumns = new BehaviorSubject(null);
  public dynamicColumnIndexMap = new BehaviorSubject(null);
  public columnIndexMap: { [key: string]: number };
  public groupingData$ = new BehaviorSubject(null);
  public filterFormControl: FormControl;
  public listConfig: IListConfig = {
    listType: 'STUDENT',
    noDataMessage: 'No students to display',
    sortableColumns: true,
  };
  public noDataMessage: any;
  public sortKey$: BehaviorSubject<string>;
  public sortDirection$: BehaviorSubject<TSortDirections>;
  public updateSort: Function;
  public shelterId: string;

  // SubSinks
  public notificationServiceSub: Unsubscribable;
  public batchActionsModeSubscription: Unsubscribable;
  public filterSub: Unsubscribable;

  // Refs
  @ViewChild('entry', { read: ViewContainerRef, static: true }) entry: ViewContainerRef;
  @ViewChild('listContent', { static: true }) listContent: ElementRef;

  // DI
  constructor(
    public resolver: ComponentFactoryResolver,
    public listSummaryGroupings: ListSummaryGroupings,
    public madlibService: MadlibService,
    public objectCache: ObjectCache,
    public notificationService: BackgroundJobNotificationService,
    private navigationService: NgRouterNavigationService,
    public shelterDataService: ShelterDataService,
    private store: Store<any>,
    private listHeaderService: ListHeaderService,
    private route: ActivatedRoute,
    public spinnerService: SpinnerService,
    @Inject('$state') public $state: IStateService,
  ) {
    // We are extending the fixed-to-infinite functionality
    super(resolver);
  }

  ngOnInit(): void {
    this.shelterId = this.route.snapshot.params.shelterId;
    this.queryParams = this.route.snapshot.queryParams;
    // Clear the cache on initialization. User *may* have changed schools.
    this.shelterDataService.clearFociCache();
    // Kick off data pipeline `getFoci$---generateMadlibModel---getGrouping$---createListContainer---|`
    this.initializeAttendanceList(this.schoolId, true);
    // Overwrite super methods -- how we respond to user events

    // Called by super; when in each of the list modes
    this.onFixed = this.updateCssForListType('FIXED');
    this.onInfinite = this.updateCssForListType('INFINITE');

    this.onUiRowDataUpdate = ($event: IGroupData[]) => {
      const groupings = $event;
      this.uiRowData = groupings;
      this.updateContentToolsData(groupings);
    };

    this.filterFormControl = new FormControl(this.queryParams.search || null);
    this.sortKey$ = new BehaviorSubject(this.queryParams.sortKey || 'SHELTER_STUDENT_NAME');
    this.sortDirection$ = new BehaviorSubject<TSortDirections>(this.queryParams.sortDirection || Direction.asc);
    // Super Props
    this.updateSort = (sortKey: string) => {
      SortAndFilterService.updateSortCol(sortKey, this.sortKey$, this.sortDirection$);
      const params = this.createUrlParams();
      const extras = this.createUrlPayload(params);
      this.navigationService.updateUrl([], extras);
    };

    this.onRowClick = e => {
      const { caresId } = JSON.parse(e[0].meta);
      const caresIds = [caresId];
      const payload = {
        caresIds,
        updateRelPath: `shelter/${this.shelterId}/profile`,
        queryParamsHandling: '',
        route: null,
      };
      this.navigationService.goToProfile(payload);
    };

    // Update URL on filter change
    this.filterSub = this.filterFormControl.valueChanges
      .pipe(
        tap(() => {
          const params = this.createUrlParams();
          const extras = this.createUrlPayload(params);
          this.navigationService.updateUrl([], extras);
        }),
      )
      .subscribe();
    // Listen for completed background jobs and refetch data as needed
    this.notificationServiceSub = this.notificationService
      .getMessage()
      .pipe(
        filter(({ backgroundJob }) => this.backgroundJobDependencies.includes(backgroundJob)),
        tap(() => this.initializeAttendanceList(this.schoolId, false)),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    if (this.notificationServiceSub) this.notificationServiceSub.unsubscribe();
    if (this.batchActionsModeSubscription) this.batchActionsModeSubscription.unsubscribe();
  }

  // getFocusData---createMadlibModel---getGroupingData---createListContainer--|
  initializeAttendanceList(schoolId: string, loadContainer: boolean): void {
    const spinner = this.spinnerService.openSpinner({
      message: 'Loading...',
    });
    this.getFociData$(schoolId)
      .pipe(
        // Format and set the partials to fit the nv-dropdown
        tap(fociPartials => (this.fociByCategory = this.madlibService.getFormattedFoci(fociPartials))),
        // Once we know the default focus, fetch complete data to populate corresponding filter and grouping options
        switchMap(fociPartials =>
          this.getFociData$(schoolId, this.madlibService.getDefaultFocus(fociPartials, this.queryParams)),
        ),
        switchMap(([completeFocusData]) =>
          of(this.madlibService.setMadlibModel(this.madlibService.formatFocus(completeFocusData), this.queryParams)),
        ),
        // Set madlib model with focus containing all data
        tap(madlibModel => (this.madlibModel = madlibModel)),
        switchMap(madlibModel => this.getGroupingWithTooltips$(madlibModel)),
        tap(() => {
          const params = this.createUrlParams();
          const extras = this.createUrlPayload(params);
          this.navigationService.updateUrl([`/shelter/${this.shelterId}/lists/attendance-list`], extras);
        }),
        tap(groupingData => {
          this.updateGroupingDependentProps(groupingData);
          if (loadContainer) this.createListContainer();
          spinner.close();
        }),
      )
      .subscribe();
  }

  getModelForShelter(foci, queryParams: IStateParamsService): FormGroup {
    const { focus, filter, grouping } = queryParams;
    const initialFocusSelection = this.madlibService.getInitialFocusSelection(foci, focus);
    const initialFilterSelection = this.madlibService.getInitialFilterSelection(initialFocusSelection.filters, filter);
    const initialGroupingSelection = this.madlibService.getInitialGroupingSelection(
      initialFocusSelection.groupings,
      grouping,
    );
    return new FormGroup({
      focus: new FormControl(initialFocusSelection),
      filter: new FormControl(initialFilterSelection),
      grouping: new FormControl(initialGroupingSelection),
    });
  }

  createUrlParams(): IUrlParams {
    const params = {
      madlibModel: this.madlibModel,
      sortKey: this.sortKey$.value,
      sortDirection: this.sortDirection$.value,
      search: this.filterFormControl.value,
    };
    return params;
  }

  createUrlPayload({ madlibModel, sortKey, sortDirection, search }): INgRouterQueryParams {
    const {
      value: { filter, focus, grouping },
    } = madlibModel;
    const extras = {
      relativeTo: this.route,
      queryParams: {
        focus: focus.graphQlKey,
        filter: filter.graphQlKey,
        grouping: grouping.graphQlKey,
        sortKey,
        sortDirection,
        search,
      },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    };
    return extras;
  }

  onMadlibChange(evt: { dimension: string; data: any }, schoolId: string, madlibModel: FormGroup): void {
    const spinner = this.spinnerService.openSpinner({
      message: 'Loading...',
    });
    iif(
      () => evt.dimension === 'focus',
      this.madlibService.getModelForFocusChange(schoolId, madlibModel, evt, this.getFociData$.bind(this)),
      this.madlibService.getModelForNonFocusChange(madlibModel, evt),
    )
      .pipe(
        switchMap(madlibModel => this.getGroupingWithTooltips$(madlibModel)),
        tap(groupingData => this.updateGroupingDependentProps(groupingData)),
      )
      .subscribe({
        complete: () => {
          spinner.close();
          const params = this.createUrlParams();
          const extras = this.createUrlPayload(params);
          this.navigationService.updateUrl([`/shelter/${this.shelterId}/lists/attendance-list`], extras);
        },
      });
  }

  private getGroupingWithTooltips$(madlibModel) {
    return this.shelterDataService
      .getShelterGroupingData$(
        this.madlibService.getGroupingDataPayload(this.schoolId, madlibModel.value),
        this.shelterId,
      )
      .pipe(
        switchMap(({ data: { PartnerGroupings } }) =>
          this.appendGroupTooltips(PartnerGroupings, this.madlibModel.value.grouping),
        ),
      );
  }

  updateCssForListType(listMode: 'INFINITE' | 'FIXED'): Function {
    return (instance?: ElementRef): void => {
      this.activeList = listMode;
      const addClassForListMode = listMode === 'INFINITE' ? 'infinite' : 'fixed';
      this.listContent.nativeElement.classList.add(addClassForListMode);
      const removeClassForListMode = listMode === 'INFINITE' ? 'fixed' : 'infinite';
      this.listContent.nativeElement.classList.remove(removeClassForListMode);
      this.pageHeaderMeta =
        listMode === 'INFINITE'
          ? { ...this.pageHeaderMeta, ...{ icon: this.listHeaderService.getInfiniteHeaderIcon(instance) } }
          : { ...this.pageHeaderMeta, ...{ icon: this.listHeaderService.getFixedHeaderIcon() } };
    };
  }

  getFociData$(shelterId: string, focusKey?: string): Observable<any> {
    return this.shelterDataService.getShelterFocusData$(shelterId, focusKey).pipe(
      switchMap(({ data: { ShelterFocus } }) => of(ShelterFocus)),
      take(1),
    );
  }

  appendGroupTooltips(groupings, groupingData): Observable<IGroupData> {
    const groupingsWithTooltips = groupings.reduce((accum, group) => {
      const subgroupData = groupingData.groupingSubgroups
        ? groupingData.groupingSubgroups.find(subgroup => subgroup.label === group.key)
        : null;
      const appendedGroup = { ...group, ...{ tooltip: subgroupData ? subgroupData.headerTooltip : null } };
      accum.push(appendedGroup);
      return accum;
    }, []);
    return of(groupingsWithTooltips);
  }

  updateContentToolsData(groupData: IGroupData[], visibleGroupings?: string[]): void {
    const groupings = visibleGroupings ? groupData.filter(group => visibleGroupings.includes(group.key)) : groupData;
    this.listData = this.listSummaryGroupings.getExportListData({
      groupings,
      columns: this.madlibService.getColumnDataBasedOnMadlibModel(this.madlibModel).columns,
      madlibModel: this.madlibModel,
      listType: 'Attendance',
    });
    this.listSummaryGroupings.setGroupingsV2(this.madlibModel.value, groupings);
  }

  updateGroupingDependentProps(groupingData): void {
    const { columns, columnIndexMap } = this.madlibService.getColumnDataBasedOnMadlibModel(this.madlibModel);
    this.dynamicColumns.next(columns);
    this.dynamicColumnIndexMap.next(columnIndexMap);
    this.groupingData$.next(groupingData);
    this.updateContentToolsData(groupingData);
  }
}
